import React, {useEffect, useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { PageLoading } from '../../Components/Loading';
import { useWhatsNew } from '../../Data/WhatsNew';
import nl2br from 'react-nl2br';
import Button from '../../Components/Button/Button';
import ButtonRow from '../../Components/Button/ButtonRow';
import TimeAgo from '../../Components/Formatting/TimeAgo';
import { useSession } from '../../Components/Session';

const WhatsNew = () => {
    const {whatsNew, isSaving, isLoading, giveFeedback} = useWhatsNew(true);
    const {notifications, markMatchingNotificationsSeen} = useSession();

    useEffect(() => {
        markMatchingNotificationsSeen(n => n.entityModel === 'Soapy/WhatsNewNotification');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [whatsNew, notifications]);

    return <>
        <TopBar left="BackBtn" title="What's new" />
        <Page>
            {whatsNew ? <Inner {...{whatsNew, giveFeedback, isSaving, isLoading}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({whatsNew, giveFeedback, isSaving, isLoading}) => {
    return <div className="flex flex-col divide-y w-full">
        {whatsNew.map((item, i) => <Row key={i} {...item} {...{giveFeedback, isSaving, isLoading}} />)}
    </div>
}

const Row = ({id, title, description, announcedAt, url, cta, feedback, giveFeedback, isSaving, isLoading}) => {
    return <div className="flex flex-row justify-between py-5 first:pt-0">
        <div className="flex flex-col w-full">
            <div className="text-lg font-bold text-brand">{title}</div>
            <div className="text-sm text-muted mb-2">
                <TimeAgo dateTime={announcedAt} />
            </div>
            <div className="text-sm text-gray-900">{nl2br(description)}</div>
            <div className="flex flex-row justify-between mt-4">
                <Vote {...{id, feedback, giveFeedback, isSaving, isLoading}} />

                {url && <ButtonRow>
                    <Button theme="primary" link={url} label={cta ?? 'Try it out'} />
                </ButtonRow>}
            </div>
        </div>
    </div>
}

const Vote = ({id, feedback, giveFeedback, isSaving, isLoading}) => {
    const {up, down, user} = feedback;
    const [givenFeedback, setGivenFeedback] = useState(null);
    const {isAdmin} = useSession();

    const doFeedback = (feedback) => {
        setGivenFeedback(feedback);
        giveFeedback(id, feedback);
    }

    return <div className="flex flex-row gap-2">
        <Button
            theme={user === -1 ? 'lightPrimary' : 'light'}
            loading={(isSaving || isLoading) && givenFeedback === -1}
            disabled={isSaving || isLoading}
            iconTheme={user === -1 ? 'solid' : 'light'}
            icon="ThumbsDown"
            label={(isAdmin() && down) ? down : null}
            onClick={() => doFeedback(-1)}
        />
        <Button
            theme={user === 1 ? 'lightPrimary' : 'light'}
            loading={(isSaving || isLoading) && givenFeedback === 1}
            disabled={isSaving || isLoading}
            iconTheme={user === 1 ? 'solid' : 'light'}
            icon="ThumbsUp"
            label={(isAdmin() && up) ? up : null}
            onClick={() => doFeedback(1)}
        />
    </div>
}

export default WhatsNew;
